import { render, staticRenderFns } from "./activityEditSemester.html?vue&type=template&id=039820e4&scoped=true&"
import script from "./activityEditSemester.vue?vue&type=script&lang=js&"
export * from "./activityEditSemester.vue?vue&type=script&lang=js&"
import style0 from "./activityEditSemester.css?vue&type=style&index=0&id=039820e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039820e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VSelect,VSpacer})
